import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_VERSION } from '../version';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer style={{
      background: 'white',
      borderTop: '1px solid #E5E7EB',
      padding: '2rem 1rem',
      marginTop: '4rem'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem'
      }}>
        {/* Links */}
        <div style={{
          display: 'flex',
          gap: '2rem',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}>
          <Link
            to="/impressum"
            style={{
              color: '#666',
              textDecoration: 'none',
              fontSize: '0.9rem',
              transition: 'color 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#FF6B35'}
            onMouseOut={(e) => e.currentTarget.style.color = '#666'}
          >
            📋 Impressum & Datenschutz
          </Link>
        </div>

        {/* Copyright */}
        <div style={{
          color: '#999',
          fontSize: '0.85rem',
          textAlign: 'center'
        }}>
          © {new Date().getFullYear()} VoltFox - Alle Rechte vorbehalten
        </div>

        {/* Creator Badge with Version */}
        <div style={{
          fontSize: '0.85rem',
          color: '#999',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}>
          <span>
            Erstellt mit ❤️ und ⚡ von{' '}
            <a
              href="https://mr-vision.ch"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#FF6B35',
                textDecoration: 'none',
                fontWeight: 600
              }}
            >
              Mr. Vision ✨
            </a>
          </span>
          <span style={{ color: '#CCC' }}>•</span>
          <span style={{
            background: '#F3F4F6',
            padding: '0.25rem 0.5rem',
            borderRadius: '6px',
            fontSize: '0.75rem',
            fontWeight: 600,
            color: '#666'
          }}>
            v{APP_VERSION}
          </span>
        </div>
      </div>
    </footer>
  );
}
